export const Colors = {
  primary: '#05A0D9', // Trust Blue 500
  primaryLight: '#8CE4F9', // Trust Blue 300
  primaryDark: '#02719A', // Trust Blue 700
};

export default Colors;
